import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiPostFetcher } from '@/common/api/fetcher'
import {
  CompareWithPreviousResponse,
  CompareWithPreviousVars,
  GetLlmoHistoryDetailResponse,
  GetLlmoHistoryDetailVars,
  LlmoApiPath,
  RunLlmoAnalysisResponse,
  RunLlmoAnalysisVars
} from '@/common/api/params/llmo'

// バックグラウンド実行を起動する（レコードを作成し、即座に id/status を返す）。
// シェア・オブ・ボイス／センチメント／クエリファンアウトの3種別で共通。
// vars.analysis_type で種別を指定し、レスポンスの analysis_type で遷移先を決められる。
export const useRunLlmoAnalysisApi = (options?: {
  onSuccess?: (response: RunLlmoAnalysisResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<RunLlmoAnalysisResponse, RunLlmoAnalysisVars>(
    LlmoApiPath.RUN_LLMO_ANALYSIS,
    { ...options },
    apiPostFetcher
  )
}

// 分析結果詳細（SWR）。3種別で共通で、型引数に各種別の詳細レスポンスを渡す。
// options.refreshInterval > 0 で自動更新（分析中のポーリング用）。
// 関数形式（最新データを受け取る）も可能で、status が analyzing の間だけポーリングする用途に使う。
export const useLlmoAnalysisDetailApi = <T extends Omit<GetLlmoHistoryDetailResponse, 'result'>>(
  vars: GetLlmoHistoryDetailVars | undefined,
  options?: { refreshInterval?: number | ((latest: T | undefined) => number) }
) => {
  return useSWR<T, Response, [string, GetLlmoHistoryDetailVars] | undefined>(
    vars ? [LlmoApiPath.GET_LLMO_HISTORY_DETAIL, vars] : undefined,
    { refreshInterval: options?.refreshInterval ?? 0 }
  )
}

// 前回結果との比較（SWR）。スコアの前回値・変化量の表示に使う。
// 比較対象が無い場合は available=false が返る
export const useLlmoComparisonApi = (vars: CompareWithPreviousVars | undefined) => {
  return useSWR<
    CompareWithPreviousResponse,
    Response,
    [string, CompareWithPreviousVars] | undefined
  >(vars ? [LlmoApiPath.COMPARE_WITH_PREVIOUS, vars] : undefined)
}
